module.exports = __webpack_public_path__ + "img/exportJson4.79cf23b0.png";